export const PALLETE_PRIMARY_COLOR = "#191c1f";
export const PALLETE_SECONDARY_COLOR = "#191c1f";
export const BASE_TEXT_COLOR = "#000";
export const BACKGROUND_PRIMARY = "rgba(25, 28, 31,1)";
export const BACKGROUND_SECONDARY = "rgba(25, 28, 31,0.45)";
export const PRIMARY = "#D3B47E";
